"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chalk_1 = require("chalk");
exports.commonInvalidHandler = (key, value, utils) => [
    `Invalid ${chalk_1.default.red(utils.descriptor.key(key))} value.`,
    `Expected ${chalk_1.default.blue(utils.schemas[key].expected(utils))},`,
    `but received ${chalk_1.default.red(utils.descriptor.value(value))}.`,
].join(' ');
